import { useEffect, useState } from 'react';

export const useClientOnly = () => {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  return hasMounted;
};

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);
  const hasMounted = useClientOnly();

  useEffect(() => {
    if (hasMounted) {
      const checkMobile = () => {
        setIsMobile(window.innerWidth <= 768);
      };

      checkMobile();

      const handleResize = () => {
        checkMobile();
      };

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, [hasMounted]);

  return hasMounted ? isMobile : false;
};
